import {Reducer} from 'redux';

import {IMoneycardsRes} from '~/shared/services/bffService/api/interfaces/responses';

import {makeAsyncReducer, StateAsyncProperty} from '../../redux-toolbelt';

import {getMoneyCardsIfNeeded} from './moneyCardsActions';

export type MoneyCardsState = StateAsyncProperty<IMoneycardsRes>;

// The state is annotated so that `AppState` does not have to infer it from the action,
// which reads the slice back through the selectors
// `shouldDestroyData` is off so that a refetch keeps the cards that are already rendered
const moneyCardsReducer: Reducer<MoneyCardsState> = makeAsyncReducer<MoneyCardsState>(getMoneyCardsIfNeeded, {
  defaultData: [],
  shouldDestroyData: false,
});

export default moneyCardsReducer;
